import { synchronize as syncProcess } from '../Synchronizable/synchronize';
import { Success, success } from '../Synchronizable/SyncResult';
import { FamilyMember } from './FamilyMember';
import { subsequentSync } from './subsequentSync';
import { waitForParents } from './waitForParents';

export async function synchronize<T>(familyMember: FamilyMember<T>): Promise<Success> {
  return await syncProcess(familyMember, async recordProgress => {
    await waitForParents(synchronize, familyMember, recordProgress);

    recordProgress('Synchronizing');
    await familyMember.method(familyMember.replicationState);

    recordProgress('Synchronizing Complete');
    // Much like the syncState, the method (and its lifecycle) is maintained by the FamilyMember itself,
    // and so is intentionally mutable.
    // eslint-disable-next-line no-param-reassign
    familyMember.method = subsequentSync;
    return success;
  });
}
